import { defineComponent, inject, computed, ref, shallowRef, watch, triggerRef, onMounted, onBeforeUnmount, resolveComponent, openBlock, createElementBlock, normalizeProps, mergeProps, createVNode, withCtx, guardReactiveProps, createTextVNode, toDisplayString, createElementVNode, createCommentVNode } from "vue";
import "../index-64135f7d.mjs";
import "../i18n-35335a5c.mjs";
import { b as boundUseI18n } from "../_i18n-e414d464.mjs";
import { b as isValidIdentityFeedback } from "../malarkeyTwilioAdapter-1c296255.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import { d as debug } from "../_debug-8b5c3032.mjs";
import "../otpauth.esm-675c01d0.mjs";
import "../sudo-bad5b55e.mjs";
import { D as DateTime, i as isRecordObject } from "../helpers-674591c1.mjs";
import { u as useDefaults, _ as _export_sfc } from "../_plugin-vue_export-helper-3194dc60.mjs";
import { hookVirtualKeyboardEvents } from "../utilities/ui.es.js";
import MalarkeyAttachmentPane from "./constituants/MalarkeyAttachmentPane.es.js";
import { u as useDisplay } from "../display-d5494a6d.mjs";
import "../index-38c53cf2.mjs";
import "../index-fd2245c5.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "../index-703c58ee.mjs";
import "../index-13be80af.mjs";
import "joi";
import "../_ui-71f9b37c.mjs";
import "../MalarkeyAttachmentPane.vue_vue_type_script_lang-d0f606dc.mjs";
import "../_common-fcf3ef61.mjs";
import "../MalarkeyContactAvatar-1b079ba3.mjs";
import "../_density-8094aebe.mjs";
import "../MPasswordField.vue_vue_type_script_lang-baf1023a.mjs";
import "../_VTextField-74fe2c1a.mjs";
import "../index-dbde2d54.mjs";
import "../_proxiedModel-031e293c.mjs";
import "../flow-501bd5ba.mjs";
import "../MalarkeyContactRosterItem.vue_vue_type_script_lang-89c5ac30.mjs";
import "../_VListItem-508e4b13.mjs";
import "../MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
import "../MalarkeyConversationListItem.vue_vue_type_script_lang-3da40755.mjs";
import "../theme-96176369.mjs";
import "../getCurrentInstance-eec76705.mjs";
import "./constituants/MalarkeyChatInputForm.es.js";
const _sfc_main = defineComponent({
  name: "Malarkey",
  components: {
    MalarkeyAttachmentPane
  },
  props: {
    /**
     * A function that is called when a link is clicked in the chat message pane.
     * By default the link will be opened in a new tab.
     */
    onLinkClick: {
      type: Function,
      default: void 0
    },
    /**
     * A function which is called when attachments are uploaded to the chat message pane.
     * By default, a dialog modal will be opened within the same window to allow the user to interact with the attachments.
     * This function can be used to override the default behavior.
     */
    onAttachmentsReady: {
      type: Function,
      default: void 0
    },
    /**
     * If set to `true`, the component will display a snackbar to notify the user that an update is available.
     */
    updateable: {
      type: Boolean,
      default: false
    },
    /**
     * A function which is called when a user requests the app's "about" information.
     * By default, the function will display a dialog modal with the app's information.
     * This function can be used to override the default behavior.
     */
    onAbout: {
      type: Function,
      default: void 0
    },
    /**
     * A function which is called when a user requests the app's bug report form.
     * By default, the function will display a dialog modal with the bug report form.
     * This function can be used to override the default behavior.
     */
    onBugReport: {
      type: Function,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when a link is clicked in the chat message pane.
     * @value {string} The URL that was clicked.
     * @value {string|undefined} The id of tab that the link was clicked in.
     */
    // "link-click",
  ],
  setup(props) {
    const bus = inject("bus");
    const sounds = inject("sounds");
    const swal = inject("swal");
    const toast = inject("toast");
    const twilio = inject("twilio");
    const push = inject("push");
    const cron = inject("cron");
    const sudo = inject("sudo");
    const identity = inject("identity");
    const { smAndDown } = useDisplay();
    const { t } = boundUseI18n();
    const updateable = computed(() => props.updateable);
    const handleLinkClickDefault = (url) => {
      if ("string" !== typeof url) {
        return;
      }
      if (!url.startsWith("http")) {
        url = `http://${url}`;
      }
      if (typeof window !== "undefined") {
        window.open(url, "_blank");
      } else {
        debug(url);
      }
    };
    const handleLinkClick = (url, from) => {
      if ("function" === typeof props.onLinkClick) {
        try {
          props.onLinkClick(url, from);
        } catch (error) {
          debug("Error while handling link click", error);
          handleLinkClickDefault(url);
        }
      } else if (!from || from && from === (bus == null ? void 0 : bus.uuid)) {
        handleLinkClickDefault(url);
      }
    };
    const shouldAlert = async () => {
      if (!bus) {
        debug("should not alert: bus not found");
        return false;
      }
      const [tabs, isMain] = await Promise.all([
        bus.getActiveTabs(100),
        bus.isMain(100)
      ]);
      if (isMain) {
        return true;
      }
      const allowedTabCount = !push || !push.canPush.value ? 1 : 2;
      if (tabs.length <= allowedTabCount) {
        return true;
      }
      debug("should not alert: not main tab and not single tab", tabs, isMain);
      return false;
    };
    const handleOnConversationAdd = async (conversation) => {
      if (!bus || !sounds || !twilio) {
        return;
      }
      if (!twilio.initialized.value) {
        return;
      }
      if (conversation && conversation.notificationLevel === "muted") {
        return;
      }
      if (conversation) {
        if (!conversation.dateCreated) {
          return;
        }
        const dateCreatedDto = DateTime.fromJSDate(conversation.dateCreated);
        const dateCreatedDiffNow = dateCreatedDto.diffNow("seconds").seconds;
        if (dateCreatedDiffNow < -1) {
          return;
        }
      }
      const should = await shouldAlert();
      if (!should) {
        return;
      }
      try {
        sounds.play("onConversationAdd");
      } catch (e) {
        debug(`Error playing sound "onConversationAdd"`, e);
      }
    };
    const handleOnMessageReceived = async (message) => {
      if (!bus || !sounds) {
        debug(
          "did not play sound for message received: bus or sounds not found"
        );
        return;
      }
      const should = await shouldAlert();
      if (!should) {
        debug("did not play sound for message received: should not alert");
        return;
      }
      if (message && message.conversation && message.conversation.notificationLevel === "muted") {
        debug("did not play sound for message received: conversation muted");
        return;
      }
      if (message && twilio && twilio.me.value) {
        const sender = await message.getParticipant();
        if (sender) {
          const user = await sender.getUser();
          if (user && user.identity === twilio.me.value.identity) {
            debug("did not play sound for message received: message from self");
            return;
          }
        }
      }
      try {
        sounds.play("onMessageReceived");
      } catch (e) {
        debug(`Error playing sound "onMessageReceived"`, e);
      }
    };
    const showDefaultAttachmentsModalDialog = ref(false);
    const defaultAttachmentsModalDialogConversation = shallowRef(void 0);
    const defaultAttachmentsModalDialogFiles = shallowRef(
      void 0
    );
    const defaultAttachmentsModalDialogBindings = computed(() => ({
      // modelValue: showDefaultAttachmentsModalDialog.value,
      class: ["m-chat-attachment-dialog"],
      fullscreen: smAndDown.value,
      minWidth: smAndDown.value ? null : 310,
      maxWidth: smAndDown.value ? null : 620,
      scrim: true
    }));
    const defaultAttachmentsModalDialogPaneBindings = computed(() => ({
      conversation: defaultAttachmentsModalDialogConversation.value,
      files: defaultAttachmentsModalDialogFiles.value
    }));
    const handleOnAttachmentsReady = async (conversation, files, from, bypass = false) => {
      if ("function" === typeof props.onAttachmentsReady && !bypass) {
        try {
          props.onAttachmentsReady(conversation, files, from);
        } catch (error) {
          debug("Error while handling attachments ready", error);
          handleOnAttachmentsReady(conversation, files, from, true);
        }
      } else if (!showDefaultAttachmentsModalDialog.value && conversation && Array.isArray(files) && files.length > 0 && (from && from === bus.uuid || !from)) {
        defaultAttachmentsModalDialogConversation.value = conversation;
        defaultAttachmentsModalDialogFiles.value = files;
        triggerRef(showDefaultAttachmentsModalDialog);
        triggerRef(defaultAttachmentsModalDialogConversation);
        showDefaultAttachmentsModalDialog.value = true;
      }
    };
    watch(
      () => showDefaultAttachmentsModalDialog.value,
      (is) => {
        if (!is) {
          defaultAttachmentsModalDialogConversation.value = void 0;
          defaultAttachmentsModalDialogFiles.value = void 0;
          triggerRef(defaultAttachmentsModalDialogConversation);
          triggerRef(defaultAttachmentsModalDialogFiles);
        }
      },
      { immediate: true }
    );
    const appUpdatePending = computed(() => updateable.value);
    const shouldRenderGlobalElement = computed(
      () => showDefaultAttachmentsModalDialog.value || appUpdatePending.value
    );
    const globalElementBindings = computed(() => ({
      class: ["m-core"]
    }));
    const onKeyUp = (event) => {
      if (event.key === "Escape") {
        showDefaultAttachmentsModalDialog.value = false;
      }
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
      }
    };
    const onContextMenu = (event) => {
      {
        const target = event.target;
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
          return;
        }
        event.preventDefault();
      }
    };
    const onDrop = (event) => {
      event.preventDefault();
    };
    const onDragOver = (event) => {
      event.preventDefault();
    };
    const onAttachmentImagePreview = (imageUrl) => {
      if (swal) {
        swal.fire({
          imageUrl,
          showCloseButton: true,
          showConfirmButton: false,
          showCancelButton: false,
          allowOutsideClick: true,
          allowEscapeKey: true,
          allowEnterKey: true
        });
      }
    };
    const appUpdatePendingBindings = computed(() => ({
      ...useDefaults({}, "MalarkeyAppUpdateSnackbar"),
      closeOnBack: false,
      closeOnContentClick: false,
      color: "background",
      location: "bottom start",
      modelValue: appUpdatePending.value,
      position: "fixed",
      timeout: -1
    }));
    const appUpdateInProgress = ref(false);
    const onUpdateApp = async () => {
      if (push) {
        appUpdateInProgress.value = true;
        await push.update();
        appUpdateInProgress.value = false;
      }
    };
    const onSwNotificationConversationClick = (info) => {
      debug("onSwNotificationConversationClick", info);
    };
    const onServiceWorkerPostMessage = (event) => {
      if (event.data && "string" === typeof event.data.type) {
        switch (event.data.type) {
          case "focus-conversation":
            if (bus) {
              bus.emit(
                "conversation:focus",
                { local: true },
                event.data.conversation_sid
              );
            }
            break;
        }
      }
      debug("onServiceWorkerPostMessage", event);
    };
    const doRosterUpdateCron = () => {
      if (twilio) {
        twilio.doRosterUpdate();
      }
    };
    const onVirtualkeyboardChange = (e) => {
      if (bus) {
        const { visible } = e.detail;
        bus.emit("virtualkeyboard:change", { local: true }, visible);
        debug("virtualkeyboard:change", visible);
      }
    };
    const onVirtualkeyboardShow = () => {
      if (bus) {
        bus.emit("virtualkeyboard:show", { local: true });
        debug("virtualkeyboard:show");
      }
    };
    const onVirtualkeyboardHide = () => {
      if (bus) {
        bus.emit("virtualkeyboard:hide", { local: true });
        debug("virtualkeyboard:hide");
      }
    };
    const onVirtualkeyboardUnknown = () => {
      if (bus) {
        bus.emit("virtualkeyboard:unknown", { local: true });
        debug("virtualkeyboard:unknown");
      }
    };
    const doOnAbout = (from) => {
      if ("function" === typeof props.onAbout) {
        props.onAbout(from);
      } else if (!from || from && from === (bus == null ? void 0 : bus.uuid)) {
        alert("About dialog not implemented");
      }
    };
    const doOnBugReport = (from) => {
      if ("function" === typeof props.onBugReport) {
        props.onBugReport(from);
      } else if (!from || from && from === (bus == null ? void 0 : bus.uuid)) {
        alert("Bug report dialog not implemented");
      }
    };
    const onLongtouch = (e) => {
      if (bus) {
        bus.emit("longtouch", { local: true }, e.detail);
        debug("longtouch");
      }
    };
    const impersonate = (type, id) => {
      if (!sudo || !identity) {
        return;
      }
      sudo.getImpersonatedIdentity(type, id).then(({ status, data }) => {
        if (201 !== status) {
          throw new Error("Failed to impersonate");
        }
        if (isRecordObject(data) && "data" in data && isValidIdentityFeedback(data.data)) {
          const {
            bearer,
            expiration,
            identity: id2,
            type: type2,
            username
          } = data.data;
          identity.login(bearer, expiration, {
            id: id2,
            type: type2,
            username
          });
        }
      });
    };
    const onClientAssigned = async (payload) => {
      if (!toast) {
        return;
      }
      const should = await shouldAlert();
      if (!should) {
        debug("did not alert for new client assignment: should not alert");
        return;
      }
      toast.fire({
        icon: "info",
        title: t("notices.agent.client.assigned.title"),
        text: t("notices.agent.client.assigned.text", {
          identifier: payload.clientIdentifier,
          name: payload.clientName
        })
      });
    };
    const onClientUnassigned = async (payload) => {
      if (!toast) {
        return;
      }
      const should = await shouldAlert();
      if (!should) {
        debug("did not alert for client unassignment: should not alert");
        return;
      }
      toast.fire({
        icon: "info",
        title: t("notices.agent.client.unassigned.title"),
        text: t("notices.agent.client.unassigned.text", {
          identifier: payload.clientIdentifier,
          name: payload.clientName
        })
      });
    };
    onMounted(() => {
      if (bus) {
        bus.on("link:clicked", handleLinkClick, {
          local: true,
          crossTab: true
        });
        bus.on("twilio:client:conversationAdded", handleOnConversationAdd, {
          local: true
        });
        bus.on("twilio:client:messageAdded", handleOnMessageReceived, {
          local: true
        });
        bus.on("attachments:ready", handleOnAttachmentsReady, {
          local: true,
          crossTab: true
        });
        bus.on("attachments:preview:image", onAttachmentImagePreview, {
          local: true
        });
        bus.on(
          "sw:notification:conversation:click",
          onSwNotificationConversationClick,
          {
            crossTab: true
          }
        );
        bus.on(
          "background:sw:notification:conversation:click",
          onSwNotificationConversationClick,
          {
            crossTab: true
          }
        );
        bus.on("app:open:about", doOnAbout, { local: true, crossTab: true });
        bus.on("app:open:bugreport", doOnBugReport, {
          local: true,
          crossTab: true
        });
        bus.on("event:client:assigned", onClientAssigned, {
          local: true,
          crossTab: true
        });
        bus.on("event:client:unassigned", onClientUnassigned, {
          local: true,
          crossTab: true
        });
      }
      if ("undefined" !== typeof window) {
        window.impersonate = impersonate;
        hookVirtualKeyboardEvents(window);
        window.addEventListener("keyup", onKeyUp);
        window.addEventListener("keydown", onKeyDown);
        window.addEventListener("contextmenu", onContextMenu);
        window.addEventListener("drop", onDrop);
        window.addEventListener("dragover", onDragOver);
        if ("navigator" in window && "serviceWorker" in navigator) {
          window.navigator.serviceWorker.addEventListener(
            "message",
            onServiceWorkerPostMessage
          );
        }
        window.addEventListener(
          "virtualkeyboard:change",
          onVirtualkeyboardChange
        );
        window.addEventListener("virtualkeyboard:show", onVirtualkeyboardShow);
        window.addEventListener("virtualkeyboard:hide", onVirtualkeyboardHide);
        window.addEventListener(
          "virtualkeyboard:unknown",
          onVirtualkeyboardUnknown
        );
        window.addEventListener("longtouch", onLongtouch);
      }
      if (cron) {
        cron.$on("*/5 * * * *", doRosterUpdateCron);
      }
    });
    onBeforeUnmount(() => {
      if (bus) {
        bus.off("link:clicked", handleLinkClick, { local: true });
        bus.off("twilio:client:conversationAdded", handleOnConversationAdd, {
          local: true
        });
        bus.off("twilio:client:messageAdded", handleOnMessageReceived, {
          local: true
        });
        bus.off("attachments:ready", handleOnAttachmentsReady, {
          local: true
        });
        bus.off("attachments:preview:image", onAttachmentImagePreview, {
          local: true
        });
        bus.off(
          "sw:notification:conversation:click",
          onSwNotificationConversationClick,
          {
            crossTab: true
          }
        );
        bus.off(
          "background:sw:notification:conversation:click",
          onSwNotificationConversationClick,
          {
            crossTab: true
          }
        );
        bus.off("event:client:assigned", onClientAssigned, {
          local: true,
          crossTab: true
        });
        bus.off("event:client:unassigned", onClientUnassigned, {
          local: true,
          crossTab: true
        });
      }
      if (typeof window !== "undefined") {
        window.removeEventListener("keyup", onKeyUp);
        window.removeEventListener("keydown", onKeyDown);
        window.removeEventListener("contextmenu", onContextMenu);
        window.removeEventListener("drop", onDrop);
        window.removeEventListener("dragover", onDragOver);
        if ("navigator" in window && "serviceWorker" in navigator) {
          window.navigator.serviceWorker.removeEventListener(
            "message",
            onServiceWorkerPostMessage
          );
        }
        window.removeEventListener(
          "virtualkeyboard:change",
          onVirtualkeyboardChange
        );
        window.removeEventListener(
          "virtualkeyboard:show",
          onVirtualkeyboardShow
        );
        window.removeEventListener(
          "virtualkeyboard:hide",
          onVirtualkeyboardHide
        );
        window.removeEventListener(
          "virtualkeyboard:unknown",
          onVirtualkeyboardUnknown
        );
        window.removeEventListener("longtouch", onLongtouch);
      }
      if (cron) {
        cron.$off("*/5 * * * *", doRosterUpdateCron);
      }
    });
    return {
      shouldRenderGlobalElement,
      globalElementBindings,
      showDefaultAttachmentsModalDialog,
      defaultAttachmentsModalDialogBindings,
      defaultAttachmentsModalDialogPaneBindings,
      appUpdatePending,
      appUpdatePendingBindings,
      appUpdateInProgress,
      onUpdateApp
    };
  }
});
const _hoisted_1 = ["textContent"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MalarkeyAttachmentPane = resolveComponent("MalarkeyAttachmentPane");
  const _component_v_dialog = resolveComponent("v-dialog");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_snackbar = resolveComponent("v-snackbar");
  return _ctx.shouldRenderGlobalElement ? (openBlock(), createElementBlock("div", normalizeProps(mergeProps({ key: 0 }, _ctx.globalElementBindings)), [
    createVNode(_component_v_dialog, mergeProps({
      modelValue: _ctx.showDefaultAttachmentsModalDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.showDefaultAttachmentsModalDialog = $event)
    }, _ctx.defaultAttachmentsModalDialogBindings), {
      default: withCtx(() => [
        createVNode(_component_MalarkeyAttachmentPane, mergeProps(_ctx.defaultAttachmentsModalDialogPaneBindings, {
          onClose: _cache[0] || (_cache[0] = ($event) => _ctx.showDefaultAttachmentsModalDialog = false)
        }), null, 16)
      ]),
      _: 1
    }, 16, ["modelValue"]),
    createVNode(_component_v_snackbar, normalizeProps(guardReactiveProps(_ctx.appUpdatePendingBindings)), {
      actions: withCtx(() => [
        createVNode(_component_v_btn, {
          color: "notify",
          variant: "elevated",
          loading: _ctx.appUpdateInProgress,
          onClick: _ctx.onUpdateApp
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.$t("mMalarkeyAppUpdateSnackbar.action")), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: withCtx(() => [
        createElementVNode("span", {
          textContent: toDisplayString(_ctx.$t("mMalarkeyAppUpdateSnackbar.title"))
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 16)
  ], 16)) : createCommentVNode("", true);
}
const Malarkey = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "Malarkey.vue"]]);
export {
  Malarkey as default
};
//# sourceMappingURL=Malarkey.es.js.map
